import { render, staticRenderFns } from "./input_data_pengurangan_pbb.vue?vue&type=template&id=876c4bac&"
import script from "./input_data_pengurangan_pbb.vue?vue&type=script&lang=js&"
export * from "./input_data_pengurangan_pbb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports